var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "deliverable-listing social-media grouped-by-date pt-0",
      class: {
        hasFilter:
          _vm.filterQuery.status.length ||
          _vm.filterQuery.coordinator.length ||
          _vm.filterQuery.tag.length ||
          _vm.filterQuery.outlet.length
      },
      attrs: { tabindex: "-1" }
    },
    [
      _c("div", [
        _c(
          "div",
          { staticClass: "deliverable-header " },
          [
            _c("HeaderIcon", {
              attrs: {
                totalDeliverableCount: this.allDeliverablesPaginationData.total
                  ? this.allDeliverablesPaginationData.total
                  : 0,
                totalOutletCount: this.outletCount ? this.outletCount : 0,
                myWeek: _vm.myWeek,
                title: _vm.getGroupHeading,
                groupTypeTitle: _vm.getGroupType,
                campaignId: _vm.socialCampaignId,
                seriesId: _vm.socialSeriesId,
                masterDeliverableId: _vm.masterDeliverableId,
                parentDeliverableId: _vm.parentDeliverableId,
                namespace: _vm.namespace
              },
              on: { toggleExpanded: _vm.toggleExpanded }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "deliverable-block" }, [
          _c("div", { staticClass: "delv-block-resp" }, [
            _c("div", { staticClass: "d-flex flex-row dbox-wrapper" }, [
              _c(
                "div",
                { staticClass: "dbox-left-side dleft-inner-wrap" },
                [
                  _c(
                    "b-collapse",
                    {
                      attrs: {
                        visible: _vm.expanded,
                        id: "task-listing-collapse-" + Math.random()
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.dataLoading,
                              expression: "dataLoading"
                            }
                          ],
                          staticStyle: {
                            left: "50%",
                            border: "none",
                            background: "transparent",
                            "z-index": "9000"
                          },
                          attrs: { id: "global-spinner-above-list" }
                        },
                        [_c("b-spinner", { attrs: { label: "Loading" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "dtable" },
                        [
                          _c(
                            "div",
                            { staticClass: "dtr top-row social list-labels" },
                            [
                              _c(
                                "div",
                                { staticClass: "dtd info-heading titles" },
                                [_c("span", [_vm._v("Post Name")])]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "dtd info-heading message-counter"
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dtd info-heading users" },
                                [_c("span", [_vm._v("People")])]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "dtd info-heading publish-date"
                                },
                                [_c("span", [_vm._v("Posting Date")])]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.listedLanguages, function(lang) {
                                return _c(
                                  "div",
                                  { staticClass: "dtd info-heading caption" },
                                  [_c("span", [_vm._v("Post Copy")])]
                                )
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dtd info-heading thumbnail" },
                                [_c("span", [_vm._v("Image, Alt Tag")])]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "dtd info-heading social-network"
                                },
                                [_c("span", [_vm._v("Platforms")])]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "dtd info-heading languages" },
                                [_c("span", [_vm._v("EN/FR")])]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "dtd info-heading publish-status"
                                },
                                [_c("span", [_vm._v("Status")])]
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.allDeliverables, function(
                            deliverable,
                            index
                          ) {
                            return _c(
                              "div",
                              {
                                key: "deliverable" + index,
                                ref: "listing-row",
                                refInFor: true,
                                staticClass: "dtr listing-row",
                                class: _vm.getRowClass(deliverable, index),
                                attrs: { "data-deliverable-id": deliverable.id }
                              },
                              [
                                false
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "dtd infos calendar-type"
                                      },
                                      [
                                        _vm.userCanEditDeliverable()
                                          ? _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-tooltip",
                                                    rawName:
                                                      "v-b-tooltip.hover",
                                                    modifiers: { hover: true }
                                                  },
                                                  {
                                                    name: "click-outside",
                                                    rawName: "v-click-outside",
                                                    value: _vm.deleteDeliverableClickOutside(
                                                      deliverable.id
                                                    ),
                                                    expression:
                                                      "deleteDeliverableClickOutside(deliverable.id)"
                                                  }
                                                ],
                                                class:
                                                  "delete-bar " +
                                                  (deliverable.id ==
                                                  _vm.stripRemoveDeliverableId
                                                    ? "hovered"
                                                    : ""),
                                                style: _vm.getDeliverableSideBarStyle(
                                                  deliverable
                                                ),
                                                attrs: {
                                                  title: "Delete",
                                                  tabindex: "0"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.deleteDeliverableClick(
                                                      deliverable
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("span", [
                                                  _c("i", {
                                                    staticClass: "fas fa-trash"
                                                  })
                                                ])
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "dtd titles breakpoint__fix",
                                    style: _vm.infoColStyle(deliverable),
                                    attrs: { tabindex: "-1" }
                                  },
                                  [
                                    _c("ListDeliverableStatusBar", {
                                      attrs: {
                                        deliverable: deliverable,
                                        namespace: _vm.namespace,
                                        tabindex: "0"
                                      },
                                      on: {
                                        deleteDeliverable:
                                          _vm.deleteDeliverableClick,
                                        duplicateDeliverable:
                                          _vm.duplicateDeliverable
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm.userCanEditDeliverable() && 1 == 2
                                      ? _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName: "v-b-tooltip.hover",
                                                modifiers: { hover: true }
                                              },
                                              {
                                                name: "click-outside",
                                                rawName: "v-click-outside",
                                                value: _vm.deleteDeliverableClickOutside(
                                                  deliverable.id
                                                ),
                                                expression:
                                                  "deleteDeliverableClickOutside(deliverable.id)"
                                              }
                                            ],
                                            class:
                                              "delete-bar " +
                                              (deliverable.id ==
                                              _vm.stripRemoveDeliverableId
                                                ? "hovered"
                                                : ""),
                                            style: _vm.getDeliverableSideBarStyle(
                                              deliverable
                                            ),
                                            attrs: {
                                              tabindex: "0",
                                              title: "Delete"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.deleteDeliverableClick(
                                                  deliverable
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("span", [
                                              _c("i", {
                                                staticClass: "fas fa-trash"
                                              })
                                            ])
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        class:
                                          "deliverable-title edit-d-title-stacked delete-bar-left cursor-pointer",
                                        attrs: { tabindex: "0" },
                                        on: {
                                          click: function($event) {
                                            return _vm.clickDeliverableTitle(
                                              deliverable,
                                              $event
                                            )
                                          },
                                          keyup: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.clickDeliverableTitle(
                                              deliverable,
                                              $event
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "title-text" },
                                          [
                                            _vm.showManuallyUpdatedIcon(
                                              deliverable
                                            )
                                              ? _c(
                                                  "span",
                                                  { staticClass: "link-icon" },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fas fa-unlink"
                                                    })
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(deliverable.title) +
                                                " \n\t\t\t\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "mobile-task-expand-button-area"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "mobile-task-exp-btn"
                                          },
                                          [
                                            _c("CollapseTaskBtn", {
                                              attrs: {
                                                deliverable: deliverable,
                                                index: index,
                                                expandAll: _vm.expanded,
                                                namespace: _vm.namespace
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm._l(
                                  _vm._.filter(deliverable.customFields, {
                                    field_key: "user"
                                  }),
                                  function(field, index) {
                                    return !_vm.isMobile()
                                      ? _c(
                                          "div",
                                          {
                                            key:
                                              "" +
                                              deliverable.id +
                                              field.field_id,
                                            staticClass:
                                              "dtd infos cursor-pointer",
                                            attrs: { tabindex: "0" },
                                            on: {
                                              click: function($event) {
                                                return _vm.clickTaskUsers(
                                                  deliverable
                                                )
                                              },
                                              keyup: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                $event.stopPropagation()
                                                return _vm.clickTaskUsers(
                                                  deliverable,
                                                  $event
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("SocialCustomFields", {
                                              attrs: {
                                                customField: field,
                                                deliverable: deliverable,
                                                namespace: _vm.namespace
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  }
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dtd infos message-counter cursor-pointer",
                                    attrs: { tabindex: "0" },
                                    on: {
                                      click: function($event) {
                                        return _vm.clickDeliverableCommentsCell(
                                          deliverable,
                                          $event
                                        )
                                      },
                                      keyup: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        $event.stopPropagation()
                                        return _vm.clickDeliverableComments(
                                          deliverable,
                                          $event
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("SocialPostMessageCounter", {
                                      attrs: {
                                        deliverable: deliverable,
                                        namespace: _vm.namespace
                                      },
                                      on: {
                                        clickMessageCounter: function($event) {
                                          return _vm.clickDeliverableComments(
                                            deliverable
                                          )
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dtd infos users cursor-pointer",
                                    attrs: { tabindex: "0" },
                                    on: {
                                      click: function($event) {
                                        return _vm.clickTaskUsers(
                                          deliverable,
                                          $event
                                        )
                                      },
                                      keyup: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        $event.stopPropagation()
                                        return _vm.clickTaskUsers(
                                          deliverable,
                                          $event
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("span"),
                                    _vm._v(" "),
                                    _c("DeliverableListUsers", {
                                      attrs: { deliverable: deliverable }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                deliverable.is_master == 0 && 1 == 2
                                  ? _c(
                                      "div",
                                      { staticClass: "dtd infos publish-date" },
                                      [
                                        _vm.showManuallyUpdatedIcon(deliverable)
                                          ? _c(
                                              "span",
                                              { staticClass: "link-icon" },
                                              [
                                                _c("i", {
                                                  staticClass: "fas fa-unlink"
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("DeliverablePublishDatePicker", {
                                          attrs: {
                                            deliverable: deliverable,
                                            namespace: _vm.namespace
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                deliverable.is_master == 0
                                  ? _c(
                                      "div",
                                      { staticClass: "dtd infos publish-date" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName: "v-b-tooltip.hover",
                                                modifiers: { hover: true }
                                              }
                                            ],
                                            attrs: {
                                              title: _vm.getPublishStatusText(
                                                deliverable.publish_status
                                              )
                                            }
                                          },
                                          [
                                            deliverable.publish_date
                                              ? _c("span", {
                                                  class: _vm.getPublishStatusClass(
                                                    deliverable.publish_status
                                                  ),
                                                  style: _vm.getPublishDateStyle(
                                                    deliverable.publish_date
                                                  ),
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.formatDate(
                                                        deliverable.publish_date
                                                      )
                                                    )
                                                  }
                                                })
                                              : _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "not-set exclude-outside-click"
                                                  },
                                                  [_vm._v("No Date")]
                                                )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                deliverable.is_master == 1
                                  ? _c(
                                      "div",
                                      { staticClass: "dtd infos publish-date" },
                                      [
                                        _vm.getNoDateText(
                                          deliverable.social_series_deliverables
                                        )
                                          ? _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.getNoDateText(
                                                    deliverable.social_series_deliverables
                                                  )
                                                )
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm._l(
                                          deliverable.social_series_deliverables.filter(
                                            function(v) {
                                              return v.publish_date != null
                                            }
                                          ),
                                          function(ssd, ssd_idx) {
                                            return _c("span", [
                                              ssd.publish_date
                                                ? _c("span", {
                                                    directives: [
                                                      {
                                                        name: "b-tooltip",
                                                        rawName:
                                                          "v-b-tooltip.hover",
                                                        modifiers: {
                                                          hover: true
                                                        }
                                                      }
                                                    ],
                                                    class: _vm.getPublishStatusClass(
                                                      ssd.publish_status
                                                    ),
                                                    style: _vm.getPublishDateStyle(
                                                      ssd.publish_date
                                                    ),
                                                    attrs: {
                                                      title: _vm.getPublishStatusText(
                                                        ssd.publish_status
                                                      )
                                                    },
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.formatDate(
                                                          ssd.publish_date
                                                        )
                                                      )
                                                    }
                                                  })
                                                : _vm._e()
                                            ])
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dtd infos caption cursor-pointer",
                                    attrs: { tabindex: "0" },
                                    on: {
                                      click: function($event) {
                                        return _vm.clickPostCopy(
                                          deliverable,
                                          $event
                                        )
                                      },
                                      keyup: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        $event.stopPropagation()
                                        return _vm.clickPostCopy(
                                          deliverable,
                                          $event
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("div", {
                                      staticClass: "char-count",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.getCaption(deliverable, true)
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "caption-text",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.getCaption(deliverable)
                                        )
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass:
                                    "dtd infos thumbnail cursor-pointer",
                                  attrs: { tabindex: "0" },
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.getSocialPostThumbnailAndAltText(
                                        deliverable
                                      )
                                    )
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.clickThumbnail(
                                        deliverable,
                                        $event
                                      )
                                    },
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      $event.stopPropagation()
                                      return _vm.clickThumbnail(
                                        deliverable,
                                        $event
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dtd infos social-networks cursor-pointer",
                                    attrs: { tabindex: "0" },
                                    on: {
                                      click: function($event) {
                                        return _vm.clickPlatforms(
                                          deliverable,
                                          $event
                                        )
                                      },
                                      keyup: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        $event.stopPropagation()
                                        return _vm.clickPlatforms(
                                          deliverable,
                                          $event
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "info-bubbles social-networks"
                                      },
                                      _vm._l(
                                        deliverable.social_networks,
                                        function(net, net_idx) {
                                          return _c(
                                            "span",
                                            {
                                              class:
                                                "social-networks initials badge badge-primary " +
                                                _vm.getSocialNetworkColorClass(
                                                  net,
                                                  deliverable
                                                ),
                                              attrs: {
                                                title: _vm.getSocialNetworkTypeById(
                                                  net
                                                )
                                              }
                                            },
                                            [
                                              _c("i", {
                                                class:
                                                  "fab fa-" +
                                                  _vm.getSocialNetworkClassById(
                                                    net
                                                  ) +
                                                  " platform-indicator"
                                              })
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dtd infos languages cursor-pointer",
                                    attrs: { tabindex: "0" },
                                    on: {
                                      click: function($event) {
                                        return _vm.clickLanguages(
                                          deliverable,
                                          $event
                                        )
                                      },
                                      keyup: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        $event.stopPropagation()
                                        return _vm.clickLanguages(
                                          deliverable,
                                          $event
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "info-bubbles languages" },
                                      _vm._l(deliverable.languages, function(
                                        lang,
                                        lang_idx
                                      ) {
                                        return _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName:
                                                  "v-b-tooltip.hover.html",
                                                modifiers: {
                                                  hover: true,
                                                  html: true
                                                }
                                              }
                                            ],
                                            staticClass:
                                              "languages initials badge badge-primary",
                                            class: _vm.getLangColorClass(
                                              lang,
                                              deliverable
                                            ),
                                            attrs: {
                                              title: _vm.getLangCodeById(lang)
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "exclude-outside-click"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getLangCodeById(lang)
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "dtd infos publish-status",
                                    attrs: { tabindex: "0" }
                                  },
                                  [
                                    _c("SocialStatusLabel", {
                                      attrs: {
                                        deliverable: deliverable,
                                        isList: true,
                                        namespace: _vm.namespace
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              2
                            )
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "dtable bottom-row social" }, [
                        _c("div", { staticClass: "dtr" }, [
                          _c(
                            "div",
                            {
                              staticClass: "dtd filtered-text d-flex",
                              attrs: { tabindex: "0" }
                            },
                            [
                              _c("pagination", {
                                attrs: {
                                  data: _vm.allDeliverablesPaginationData,
                                  "show-disabled": true,
                                  limit: 5
                                },
                                on: {
                                  "pagination-change-page": _vm.onChangePage
                                }
                              }),
                              _vm._v(" "),
                              1 == 2 &&
                              (_vm.getSystemSetting(
                                "social_media___show_new_post_button"
                              ) ||
                                _vm.showNewPostButton)
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-theme header-filter-btns social-group-new-post-btn btn-pagination",
                                      attrs: { type: "button" },
                                      on: { click: _vm.newPost }
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.getNewPostButtonText()
                                          )
                                        }
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "fas text-primary float-right fa-plus fa-fw"
                                      })
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ])
                    ]
                  )
                ],
                1
              )
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }